import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'xemex-nav-brand',
  imports: [],
  templateUrl: './nav-brand.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './nav-brand.component.scss',
})
export class NavBrandComponent {
  collapsed = input<boolean>(false);
  logoSrc = input<string>('assets/logo/logo.svg');
  logoCollapsedSrc = input<string>('assets/logo/logo-small.svg');
  alt = input<string>('Logo');
}
